/*
 * @Author: mayanxia 
 * @Date: 2020-11-18 10:48:14 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-11-09 15:24:39
 */

<template xmlns:background-color="http://www.w3.org/1999/xhtml">
  <a-row :gutter="10">
    <a-col :md="12" :sm="24">
      <a-card :bordered="false">

        <!-- 按钮操作区域 -->
        <a-row style="margin-left: 14px">
          <a-button @click="handleAdd(1)" type="primary">{{ $t('添加公司') }}</a-button>
          <!--<a-button @click="handleAdd(2)" type="primary">添加下级</a-button>-->
          <!--
          <a-button type="primary" icon="download" @click="handleExportXls('部门信息')">导出</a-button>
          <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
            <a-button type="primary" icon="import">导入</a-button>
          </a-upload>
          <a-button title="删除多条数据" @click="batchDel" type="default">批量删除</a-button>
          -->
          <!--<a-button @click="refresh" type="default" icon="reload" :loading="loading">刷新</a-button>-->
        </a-row>
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="onClearSelected">{{ $t('取消选择') }}</a>
            </div>
          </a-alert>
          <a-input-search @search="onSearch" style="width:100%;margin-top: 10px" :placeholder="$t('请输入部门名称')" />
          <!-- 树-->
          <a-col :md="24" :sm="24" style="max-height: 60vh;overflow: auto">
            <template>
              <a-dropdown :trigger="[this.dropTrigger]" @visibleChange="dropStatus">
                <span style="user-select: none">
                  <a-tree checkable multiple @select="onSelect" @check="onCheck" @rightClick="rightHandle"
                    :selectedKeys="selectedKeys" :checkedKeys="checkedKeys" :treeData="departTree"
                    :checkStrictly="checkStrictly" :expandedKeys="iExpandedKeys" :autoExpandParent="autoExpandParent"
                    @expand="onExpand" />
                </span>
                <!--新增右键点击事件,和增加添加和删除功能-->
                <a-menu slot="overlay">
                  <a-menu-item @click="handleAdd(3)" key="1">{{ $t('添加') }}</a-menu-item>
                  <a-menu-item @click="handleDelete" key="2">{{ $t('删除') }}</a-menu-item>
                  <a-menu-item @click="closeDrop" key="3">{{ $t('取消') }}</a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </a-col>
        </div>
      </a-card>
      <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
      <div class="drawer-bootom-button">
        <a-dropdown :trigger="['click']" placement="topCenter">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="switchCheckStrictly(1)">{{ $t('父子关联') }}</a-menu-item>
            <a-menu-item key="2" @click="switchCheckStrictly(2)">{{ $t('取消关联') }}</a-menu-item>
            <a-menu-item key="3" @click="checkALL">{{ $t('全部勾选') }}</a-menu-item>
            <a-menu-item key="4" @click="cancelCheckALL">{{ $t('取消全选') }}</a-menu-item>
            <a-menu-item key="5" @click="expandAll">{{ $t('展开所有') }}</a-menu-item>
            <a-menu-item key="6" @click="closeAll">{{ $t('合并所有') }}</a-menu-item>
          </a-menu>
          <a-button>
            {{ $t('树操作') }}
            <a-icon type="up" />
          </a-button>
        </a-dropdown>
      </div>
      <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
    </a-col>
    <a-col :md="12" :sm="24">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane :tab="$t('基本信息')" key="1">
          <a-card :bordered="false" v-if="selectedKeys.length>0">
            <a-form :form="form">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('机构名称')">
                <a-input :placeholder="$t('请输入机构/部门名称')" v-decorator="['departName', validatorRules.departName ]" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('上级部门')">
                <a-tree-select style="width:100%" :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
                  :treeData="treeData" :disabled="disable" v-model="model.parentId" :placeholder="$t('无')">
                </a-tree-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('机构编码')">
                <a-input disabled :placeholder="$t('请输入机构编码')" v-decorator="['orgCode', validatorRules.orgCode ]" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('机构类型')">
                <template v-if="orgCategoryDisabled">
                  <a-radio-group v-decorator="['orgCategory',validatorRules.orgCategory]" :placeholder="$t('请选择机构类型')">
                    <a-radio value="1">
                      {{ $t('公司') }}
                    </a-radio>
                  </a-radio-group>
                </template>
                <template v-else>
                  <a-radio-group v-decorator="['orgCategory',validatorRules.orgCategory]" :placeholder="$t('请选择机构类型')">
                    <a-radio value="2">
                      {{ $t('部门') }}
                    </a-radio>
                    <a-radio value="3">
                      {{ $t('岗位') }}
                    </a-radio>
                  </a-radio-group>
                </template>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('排序')">
                <a-input-number v-decorator="[ 'departOrder',{'initialValue':0}]" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('手机号')">
                <a-input :placeholder="$t('请输入手机号')" v-decorator="['mobile', {'initialValue':''}]" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('地址')">
                <a-input :placeholder="$t('请输入地址')" v-decorator="['address', {'initialValue':''}]" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('备注')">
                <a-textarea :placeholder="$t('请输入备注')" v-decorator="['memo', {'initialValue':''}]" />
              </a-form-item>
              <template v-if="orgCategoryDisabled">
                <a-form-item
                  v-for="(k, index) in form.getFieldValue('keys')"
                  :key="k"
                  v-bind="index === 0 ? formItemLayout : formItemLayoutWithOutLabel"
                  :label="index === 0 ? $t('应用ID') : ''"
                  :required="true"
                >
                  <a-input
                    v-decorator="[
                    `appId${k}`, validatorRules.appId
                    /*
                    {
                      rules: [
                        {
                          required: true,
                          whitespace: true,
                          message: '请输入应用ID'
                        }
                      ]
                    },*/
                    ]"
                    :placeholder="$t('请输入应用ID')"
                  />
                  <a-icon
                    v-if="form.getFieldValue('keys').length > 1"
                    class="dynamic-delete-button"
                    type="minus-circle-o"
                    :disabled="form.getFieldValue('keys').length === 1"
                    @click="() => removeField(k)"
                    style="margin-right:-20px"
                  />
                </a-form-item>
                <a-form-item v-bind="formItemLayoutWithOutLabel">
                  <a-button type="dashed" style="width: 60%" @click="addField">
                    <a-icon type="plus" /> Add field
                  </a-button>
                </a-form-item>
              </template>
            </a-form>
            <div class="anty-form-btn">
              <a-button @click="emptyCurrForm" type="default" htmlType="button" icon="sync">{{ $t('重置') }}</a-button>
              <a-button @click="submitCurrForm" :loading="saveLoading" type="primary" htmlType="button" icon="form">{{ $t('保存') }}</a-button>
            </div>
          </a-card>
          <a-card v-else>
            <a-empty>
              <span slot="description"> {{ $t('请先选择一个部门!') }} </span>
            </a-empty>
          </a-card>
        </a-tab-pane>
        <a-tab-pane :tab="$t('部门权限')" key="2" forceRender>
          <depart-auth-modal ref="departAuth" />
        </a-tab-pane>
        <a-tab-pane :tab="$t('用户编号')" key="3" forceRender>
          <depart-user-id-create-rule-modal ref="departUserIdCreateRule"></depart-user-id-create-rule-modal>
        </a-tab-pane>
      </a-tabs>

    </a-col>
    <depart-modal ref="departModal" @ok="loadTree"></depart-modal>
  </a-row>
</template>
<script>
  import DepartModal from './modules/DepartModal'
  import pick from 'lodash.pick'
  import {isUndefined} from'@/utils/validate'
  let idNumber = 0;
  import {
    queryDepartTreeList,
    searchByKeywords,
    deleteByDepartId
  } from '@/api/api'
  import {
    httpAction,
    deleteAction
  } from '@/api/manage'
  import {
    JeecgListMixin
  } from '@/mixins/JeecgListMixin'
  import DepartAuthModal from './modules/DepartAuthModal'
  import { getAction } from '@/api/manage'
  import { listSize } from '@/utils/util'
  import DepartUserIdCreateRuleModal  from './modules/DepartUserIdCreateRuleModal'
  export default {
    name: 'DepartList',
    mixins: [JeecgListMixin],
    components: {
      DepartAuthModal,
      DepartModal,
      DepartUserIdCreateRuleModal
    },
    data() {
      return {
        iExpandedKeys: [],
        loading: false,
        saveLoading: false,
        autoExpandParent: true,
        currFlowId: '',
        currFlowName: '',
        disable: true,
        treeData: [],
        visible: false,
        departTree: [],
        rightClickSelectedKey: '',
        rightClickSelectedOrgCode: '',
        hiding: true,
        model: {},
        dropTrigger: '',
        depart: {},
        disableSubmit: false,
        checkedKeys: [],
        selectedKeys: [],
        autoIncr: 1,
        currSelected: {},

        allTreeKeys: [],
        checkStrictly: true,

        form: this.$form.createForm(this),
        labelCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 5
          }
        },
        wrapperCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 16
          }
        },
        graphDatasource: {
          nodes: [],
          edges: []
        },
        url: {
          delete: '/sys/sysDepart/delete',
          edit: '/sys/sysDepart/edit',
          deleteBatch: '/sys/sysDepart/deleteBatch',
          exportXlsUrl: "sys/sysDepart/exportXls",
          importExcelUrl: "sys/sysDepart/importExcel",
          departAppinfoList: "/jeecg-charge/meter/departAppinfo/list",
          queryAppIdAndCompanyByAppId: "/jeecg-charge/meter/departAppinfo/list"
        },
        orgCategoryDisabled: true,
        disableMixinCreated: true,
        formItemLayout: {
          labelCol: {
            xs: { span: 24 },
            sm: { span: 5 },
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
          },
        },
        formItemLayoutWithOutLabel: {
          wrapperCol: {
            xs: { span: 24, offset: 0 },
            sm: { span: 16, offset: 5 },
          },
        }
      }
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：校验规则使用 computed 以响应语言切换
      validatorRules() {
        return {
          departName: {
            rules: [{
              required: true,
              message: this.$t('请输入机构/部门名称!')
            }]
          },
          orgCode: {
            rules: [{
              required: true,
              message: this.$t('请输入机构编码!')
            }]
          },
          orgCategory: {
            rules: [{
              required: true,
              message: this.$t('请输入机构类型!')
            }]
          },
          mobile: {
            rules: [{
              validator: this.validateMobile
            }]
          },
          appId:{rules: [
            { required: true, message: this.$t('请输入appId!') }
            ,{validator: this.validateAppId}
          ]},
        }
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [{
            title: this.$t('机构名称'),
            dataIndex: 'departName'
          },
          {
            title: this.$t('机构类型'),
            align: 'center',
            dataIndex: 'orgType'
          },
          {
            title: this.$t('机构编码'),
            dataIndex: 'orgCode',
          },
          {
            title: this.$t('手机号'),
            dataIndex: 'mobile'
          },
          {
            title: this.$t('传真'),
            dataIndex: 'fax'
          },
          {
            title: this.$t('地址'),
            dataIndex: 'address'
          },
          {
            title: this.$t('排序'),
            align: 'center',
            dataIndex: 'departOrder'
          },
          {
            title: this.$t('操作'),
            align: 'center',
            dataIndex: 'action',
            scopedSlots: {
              customRender: 'action'
            }
          }
        ]
      }
    },
    methods: {
      loadData() {
        this.refresh();
      },
      loadTree() {
        var that = this
        that.treeData = []
        that.departTree = []
        queryDepartTreeList().then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            this.allTreeKeys = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.treeData.push(temp)
              that.departTree.push(temp)
              that.setThisExpandedKeys(temp)
              that.getAllKeys(temp);
              // console.log(temp.id)
            }
            this.loading = false
          }
        })
      },
      setThisExpandedKeys(node) {
        if (node.children && node.children.length > 0) {
          this.iExpandedKeys.push(node.key)
          for (let a = 0; a < node.children.length; a++) {
            this.setThisExpandedKeys(node.children[a])
          }
        }
      },
      refresh() {
        this.loading = true
        this.loadTree()
      },
      // 右键操作方法
      rightHandle(node) {
        this.dropTrigger = 'contextmenu'
        console.log(node.node.eventKey)
        this.rightClickSelectedKey = node.node.eventKey
        this.rightClickSelectedOrgCode = node.node.dataRef.orgCode
      },
      onExpand(expandedKeys) {
        console.log('onExpand', expandedKeys)
        // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.
        this.iExpandedKeys = expandedKeys
        this.autoExpandParent = false
      },
      backFlowList() {
        this.$router.back(-1)
      },
      // 右键点击下拉框改变事件
      dropStatus(visible) {
        if (visible == false) {
          this.dropTrigger = ''
        }
      },
      // 右键店家下拉关闭下拉框
      closeDrop() {
        this.dropTrigger = ''
      },
      addRootNode() {
        this.$refs.nodeModal.add(this.currFlowId, '')
      },
      batchDel: function () {
        console.log(this.checkedKeys)
        if (this.checkedKeys.length <= 0) {
          this.$message.warning(this.$t('请选择一条记录！'))
        } else {
          var ids = ''
          for (var a = 0; a < this.checkedKeys.length; a++) {
            ids += this.checkedKeys[a] + ','
          }
          var that = this
          this.$confirm({
            title: this.$t('确认删除'),
            content: this.$t('确定要删除所选中的 {count} 条数据，以及子节点数据吗?', { count: this.checkedKeys.length }),
            onOk: function () {
              deleteAction(that.url.deleteBatch, {
                ids: ids
              }).then((res) => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.loadTree()
                  that.onClearSelected()
                } else {
                  that.$message.warning(res.message)
                }
              })
            }
          })
        }
      },
      onSearch(value) {
        let that = this
        if (value) {
          searchByKeywords({
            keyWord: value
          }).then((res) => {
            if (res.success) {
              that.departTree = []
              for (let i = 0; i < res.result.length; i++) {
                let temp = res.result[i]
                that.departTree.push(temp)
              }
            } else {
              that.$message.warning(res.message)
            }
          })
        } else {
          that.loadTree()
        }

      },
      nodeModalOk() {
        this.loadTree()
      },
      nodeModalClose() {},
      hide() {
        console.log(111)
        this.visible = false
      },
      onCheck(checkedKeys, info) {
        console.log('onCheck', checkedKeys, info)
        this.hiding = false
        //this.checkedKeys = checkedKeys.checked
        // <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
        if (this.checkStrictly) {
          this.checkedKeys = checkedKeys.checked;
        } else {
          this.checkedKeys = checkedKeys
        }
        // <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
      },
      onSelect(selectedKeys, e) {
        
        console.log('selected', selectedKeys, e)
        this.hiding = false
        let record = e.node.dataRef
        // 查询这个公司下的关联应用信息
        if (record.orgCategory == '1') {
          idNumber = 0;
          this.form.getFieldDecorator('keys', { initialValue: [], preserve: true });
          this.form.setFieldsValue({keys:[]});
          this.queryDepartAppinfoList(record);
        }
        console.log('onSelect-record', record)
        this.currSelected = Object.assign({}, record)
        this.model = this.currSelected
        this.selectedKeys = [record.key]
        this.model.parentId = record.parentId
        this.setValuesToForm(record)
        this.$refs.departAuth.show(record.id);
        this.$refs.departUserIdCreateRule.show(record.id);
      },
      // 触发onSelect事件时,为部门树右侧的form表单赋值
      setValuesToForm(record) {
        if (record.orgCategory == '1') {
          this.orgCategoryDisabled = true;
        } else {
          this.orgCategoryDisabled = false;
        }
        this.$nextTick(() => {
          this.form.getFieldDecorator('fax', {
            initialValue: ''
          })
          this.form.setFieldsValue(pick(record, 'departName', 'orgCategory', 'orgCode', 'departOrder', 'mobile',
            'fax', 'address', 'memo'))
        })
      },
      queryDepartAppinfoList(record) {
        //加载数据 若传入参数1则加载第一页的内容
        
        let params = {pageNo: 1,pageSize: listSize};//查询条件
        params.departId = record.id;
        getAction(this.url.departAppinfoList, params).then((res) => {
          if (res.success) {
            let departAppinfoList = res.result.records;
            if(departAppinfoList.length>0) {
              let length = departAppinfoList.length;
              let filedObj = {}
              for(let i =0;i<length;i++) {
                this.addField();
                filedObj[`appId${i}`] = departAppinfoList[i].appId;
              }
              console.log(filedObj)
              let that = this
              that.$nextTick(() => {
                that.form.setFieldsValue(filedObj)
              })
              /*
              setTimeout(()=>{
                //that.form.setFieldsValue(filedObj)
                this.form.getFieldDecorator('fax', {
                  initialValue: ''
                })
              },1000)
              */
            }else{
              this.addField();
            }
            
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      removeField(k) {
        const { form } = this;
        // can use data-binding to get
        const keys = form.getFieldValue('keys');
        // We need at least one passenger
        if (keys.length === 1) {
          return;
        }

        // can use data-binding to set
        form.setFieldsValue({
          keys: keys.filter(key => key !== k),
        });
      },
      addField() {
        const { form } = this;
        // can use data-binding to get
        const keys = form.getFieldValue('keys');
        const nextKeys = keys.concat(idNumber++);
        // can use data-binding to set
        // important! notify form to detect changes
        form.setFieldsValue({
          keys: nextKeys,
        });
      },
      getCurrSelectedTitle() {
        return !this.currSelected.title ? '' : this.currSelected.title
      },
      onClearSelected() {
        this.hiding = true
        this.checkedKeys = []
        this.currSelected = {}
        this.form.resetFields()
        this.selectedKeys = []
        this.$refs.departAuth.departId = ''
        this.$refs.departUserIdCreateRule.departId = ''
      },
      handleNodeTypeChange(val) {
        this.currSelected.nodeType = val
      },
      notifyTriggerTypeChange(value) {
        this.currSelected.notifyTriggerType = value
      },
      receiptTriggerTypeChange(value) {
        this.currSelected.receiptTriggerType = value
      },
      submitCurrForm() {
        this.form.validateFields((err, values) => {
          if (!err) {
            if (!this.currSelected.id) {
              this.$message.warning(this.$t('请点击选择要修改部门!'))
              return
            }
            this.saveLoading = true
            let formData = Object.assign(this.currSelected, values)
            console.log(formData)
            let arr = []
            for(let k in formData) {
              if(k.indexOf("appId")>-1) {
                delete formData[k]
              }
            }
            let keys = values.keys
            for(let i = 0;i<keys.length;i++) {
              arr.push(values['appId'+keys[i]])
            }
            if(arr.length>0) {
              formData.appIds = arr.join(',')
            }
            
            console.log('Received values of form: ', formData)
            httpAction(this.url.edit, formData, 'put').then((res) => {
              if (res.success) {
                this.$message.success(this.$t('保存成功!'))
                this.loadTree()
              } else {
                this.$message.error(res.message)
              }
            }).finally(()=> {
              this.saveLoading = false
            })
          }
        })
      },
      emptyCurrForm() {
        this.form.resetFields();
        this.orgCategoryDisabled = true;
        idNumber = 0;
        this.addField();
      },
      nodeSettingFormSubmit() {
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
          }
        })
      },
      openSelect() {
        this.$refs.sysDirectiveModal.show()
      },
      handleAdd(num) {
        if (num == 1) {
          this.$refs.departModal.add()
          this.$refs.departModal.title = this.$t('新增')
        } else if (num == 2) {
          let key = this.currSelected.key
          if (!key) {
            this.$message.warning(this.$t('请先点击选中上级部门！'))
            return false
          }
          this.$refs.departModal.add(this.selectedKeys)
          this.$refs.departModal.title = this.$t('新增')
        } else {
          this.$refs.departModal.add(this.rightClickSelectedKey)
          this.$refs.departModal.title = this.$t('新增')
        }
      },
      handleDelete() {
        var that = this
        this.$confirm({
          title: this.$t('确认删除'),
          content: this.$t('确定要删除此部门以及子节点数据吗?'),
          onOk: function () {
            deleteByDepartId({
              id: that.rightClickSelectedKey
            }).then((resp) => {
              if (resp.success) {
                //删除成功后，去除已选中中的数据
                that.checkedKeys.splice(that.checkedKeys.findIndex(key => key === that.rightClickSelectedKey),
                  1);
                that.$message.success(that.$t('删除成功!'))
                that.loadTree()
                //删除后同步清空右侧基本信息内容
                let orgCode = that.form.getFieldValue("orgCode");
                if (orgCode && orgCode === that.rightClickSelectedOrgCode) {
                  that.onClearSelected()
                }
              } else {
                that.$message.warning(that.$t('删除失败!'))
              }
            })
          }
        })
      },
      selectDirectiveOk(record) {
        console.log('选中指令数据', record)
        this.nodeSettingForm.setFieldsValue({
          directiveCode: record.directiveCode
        })
        this.currSelected.sysCode = record.sysCode
      },
      getFlowGraphData(node) {
        this.graphDatasource.nodes.push({
          id: node.id,
          text: node.flowNodeName
        })
        if (node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            let temp = node.children[a]
            this.graphDatasource.edges.push({
              source: node.id,
              target: temp.id
            })
            this.getFlowGraphData(temp)
          }
        }
      },
      // <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
      expandAll() {
        this.iExpandedKeys = this.allTreeKeys
      },
      closeAll() {
        this.iExpandedKeys = []
      },
      checkALL() {
        this.checkStriccheckStrictlytly = false
        this.checkedKeys = this.allTreeKeys
      },
      cancelCheckALL() {
        //this.checkedKeys = this.defaultCheckedKeys
        this.checkedKeys = []
      },
      switchCheckStrictly(v) {
        if (v == 1) {
          this.checkStrictly = false
        } else if (v == 2) {
          this.checkStrictly = true
        }
      },
      getAllKeys(node) {
        // console.log('node',node);
        this.allTreeKeys.push(node.key)
        if (node.children && node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            this.getAllKeys(node.children[a])
          }
        }
      },
      // <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
      // 查询用户编号是否重复
      validateAppId(rule, value, callback) {
        if(isUndefined(value)) {
          callback();
          return;
        }
        value = value.replace(/\s/g,"")
        let field = rule.field
        this.form.setFieldsValue({[field]: value})
        callback();
        /*
        let params = {appId: value}
        getAction(this.url.queryAppIdAndCompanyByAppId,params).then((res) => {
          if (res.success&&res.result.records.length>0) {
            if(this.currSelected.id&&res.result.records[0].departId === this.currSelected.id) {
              callback()
            }else{
              callback("该应用ID已被绑定，请验证后重新输入!")
            }
          } else {
            callback()
          }
        })
        */
      },

    },
    created() {
      this.currFlowId = this.$route.params.id
      this.currFlowName = this.$route.params.name
      this.loadData()
    },

  }
</script>
<style scoped>
  .ant-card-body .table-operator {
    margin: 15px;
  }

  .anty-form-btn {
    width: 100%;
    text-align: center;
  }

  .anty-form-btn button {
    margin: 0 5px;
  }

  .anty-node-layout .ant-layout-header {
    padding-right: 0
  }

  .header {
    padding: 0 8px;
  }

  .header button {
    margin: 0 3px
  }

  .ant-modal-cust-warp {
    height: 100%
  }

  .ant-modal-cust-warp .ant-modal-body {
    height: calc(100% - 110px) !important;
    overflow-y: auto
  }

  .ant-modal-cust-warp .ant-modal-content {
    height: 90% !important;
    overflow-y: hidden
  }

  #app .desktop {
    height: auto !important;
  }

  /** Button按钮间距 */
  .ant-btn {
    margin-left: 3px
  }

  .drawer-bootom-button {
    /*position: absolute;*/
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: left;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>